(ns minorodata.app.db
  (:require [datascript.core :as datascript]
            [re-posh.core :as re-posh]
            [mold-forms.model]
            [minorodata.app.model]
            [minorodata.users.model]
            [minorodata.logs.model]
            [minorodata.transform.model]
            [minorodata.transformations.model]
            [minorodata.file-ingest.model]
            [minorodata.connections.model]
            [minorodata.dag.model]
            [minorodata.webforms.model]
            [minorodata.sql-console.model]
            [minorodata.app-admin.model]
            [minorodata.ingest.model]
            [minorodata.recipes.model]
            [minorodata.data-views.model]
            [minorodata.json-flattening.model]
            [minorodata.transform-environments.api]
            [minorodata.tables-metadata.model]
            [minorodata.data-apps.model]
            [minorodata.webhooks.model]
            [minorodata.notifications.model]
            [minorodata.sandbox.model]
            [minorodata.ai-chat.model]
            [minorodata.vcs.model]
            [minorodata.analytics-models.model]
            [mold.core :refer-macros [defschemas]]))


(defschemas models-schema)


(defonce conn
  (datascript/create-conn models-schema))


(defn reset-conn! []
  (re-posh/connect! conn))
